import React from 'react';

interface AppErrorBoundaryProps {
  children: React.ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

// 렌더링 중 예외가 나도 검은 빈 화면 대신 복구 안내를 보여주는 최상위 오류 경계
export class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('[AppErrorBoundary] 렌더링 오류:', error, info.componentStack);
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    const isKo = (navigator.language || '').toLowerCase().startsWith('ko');
    return (
      <div
        translate="no"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#050505',
          color: '#e5e7eb',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          padding: 24,
        }}
      >
        <div style={{ maxWidth: 520, lineHeight: 1.6 }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>
            {isKo ? '화면을 표시하는 중 문제가 발생했습니다' : 'Something went wrong while rendering'}
          </h1>
          <ul style={{ fontSize: 14, color: '#9ca3af', paddingLeft: 18, marginBottom: 16 }}>
            <li>{isKo ? 'Chrome 자동 번역이 켜져 있다면 이 사이트 번역을 꺼 주세요.' : 'If Chrome auto-translate is on, disable it for this site.'}</li>
            <li>{isKo ? '블루투스 설정에 LINK BAND가 페어링되어 있다면 기기 삭제 후 다시 연결하세요.' : 'If LINK BAND is paired in OS Bluetooth settings, remove it and reconnect.'}</li>
          </ul>
          <pre style={{ fontSize: 12, color: '#f87171', whiteSpace: 'pre-wrap', marginBottom: 16 }}>{error.message}</pre>
          <button
            type="button"
            onClick={this.handleReload}
            style={{ padding: '8px 16px', borderRadius: 8, background: '#4f8cc9', color: '#fff', border: 'none', cursor: 'pointer' }}
          >
            {isKo ? '새로고침' : 'Reload'}
          </button>
        </div>
      </div>
    );
  }
}
